import { Alert, Button, Checkbox, Col, Divider, Form, Modal, Row, Space, Steps, Tooltip } from "antd";
import { FormDatePicker, FormRadio, FormSelect, RequiredMark } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons"
import { useForm } from "antd/es/form/Form";

const CreateSpecialModal = ({
    incomeForSpecialPeriod = [],
    deductionForSpecialPeriod = [],
    isModalOpen = false,
    onCancel = () => { },
    onCreateSpecial = () => { },
    specialPeriodDropdown = () => { },
}) => {

    const { t, i18n } = useTranslation();
    const [form] = useForm();

    const tooltipText = <span>test</span>

    const allOptions = [...incomeForSpecialPeriod, ...deductionForSpecialPeriod];

    const [checkedList, setCheckedList] = useState([]);
    const [selectedRadio, setSelectedRadio] = useState("");
    const checkAll = allOptions.length === checkedList.length;
    const indeterminate = checkedList.length > 0 && checkedList.length < allOptions.length;

    const onCheckAllChange = (e) => {
        const checkedValues = e.target.checked ? allOptions.map(option => option.value) : [];
        setCheckedList(checkedValues);

        form.setFieldsValue({
            income: checkedValues.filter(item => incomeForSpecialPeriod.some(option => option.value === item)),
            deduction: checkedValues.filter(item => deductionForSpecialPeriod.some(option => option.value === item)),
        });
    };

    const steps = [
        {
            content: (
                <>
                    <Col span={16}>
                        <Space direction="vertical" style={{ width: "100%" }} size={16}>
                            <FormSelect
                                required={true}
                                name="index"
                                label={t("payroll_period.label.calculate_in")}
                                placeholder={t("common.pleaseSelect")}
                                size="large"
                                options={specialPeriodDropdown()}
                            />
                            <FormRadio
                                required={true}
                                name="calculateType"
                                direction="vertical"
                                onChange={(e) => {
                                    setSelectedRadio(e.target.value);
                                }}
                                options={[
                                    {
                                        label: t("payroll_period.label.cal_normal"),
                                        value: "calculateNormal",
                                    },
                                    {
                                        label: t("payroll_period.label.cal_withholding"),
                                        value: "calculateWithholding",
                                    },
                                ]}
                            />
                            <FormDatePicker
                                required={true}
                                name="paymentDate"
                                label={t("payroll_period.label.payment_date")}
                                labelCol={{ span: 24 }}
                                placeholder={t("common.pleaseSelect")}
                                picker="date"
                                size="large"
                                disabled={selectedRadio === "calculateNormal"}
                                disabledDate={(current) => {
                                    return current && current < new Date().setHours(0, 0, 0, 0);
                                }}
                            />
                        </Space>
                    </Col>
                    <Col span={24} style={{ marginTop: 24, marginBottom: 24 }}>
                        <Alert
                            message={i18n.language === "en" ? "Income and deductions during this period will be used to calculate taxes, social security, and provident fund in the selected period, based on the specific conditions for each income or deduction." : "รายได้รายหักในงวดเงินเดือนพิเศษนี้ จะถูกนำไปคำนวณภาษี ประกันสังคม และกองทุนสำรองเลี้ยงชีพ ในงวดเงินเดือนที่เลือกตามเงื่อนไขการคำนวณของรายได้รายหักแต่ละรายการ"}
                            type="info"
                            showIcon
                        />
                    </Col>
                </>
            ),
        },
        {
            content: (
                <Col span={24}>
                    <Row>
                        <Space>
                            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                                {t("payroll_period.label.chooseItemToCal")}
                            </span>
                            <Tooltip title={tooltipText} color="#4EB8E0">
                                <InfoCircleOutlined />
                            </Tooltip>
                        </Space>
                    </Row>
                    <Row>
                        <Checkbox
                            indeterminate={indeterminate}
                            onChange={onCheckAllChange}
                            checked={checkAll}
                            style={{ marginTop: "16px" }}
                        >
                            {t("payroll_period.label.select_all")}
                        </Checkbox>
                        <Divider style={{ borderColor: "#EAECF0", borderWidth: "1px" }} />
                        <Col>
                            <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("payroll_period.label.income")}</span>
                            <Form.Item name="income">
                                <Checkbox.Group
                                    required={true}
                                    options={incomeForSpecialPeriod}
                                    value={checkedList.filter(item => incomeForSpecialPeriod.some(option => option.value === item))}
                                    onChange={(selectedIncomeList) => setCheckedList([...selectedIncomeList, ...checkedList.filter(item => deductionForSpecialPeriod.some(option => option.value === item))])}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        rowGap: "8px"
                                    }} />
                            </Form.Item>
                        </Col>
                        <Divider style={{ borderColor: "#EAECF0", borderWidth: "1px" }} />
                        <Col>
                            <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("deduction.entity")}</span>
                            <Form.Item name="deduction">
                                <Checkbox.Group
                                    required={true}
                                    options={deductionForSpecialPeriod}
                                    value={checkedList.filter(item => deductionForSpecialPeriod.some(option => option.value === item))}
                                    onChange={(selectedDeductionList) => setCheckedList([...checkedList.filter(item => incomeForSpecialPeriod.some(option => option.value === item)), ...selectedDeductionList])}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        rowGap: "8px"
                                    }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
            ),
        },
    ];

    const [current, setCurrent] = useState(0);

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));

    return (
        <Modal
            destroyOnClose
            title={t("payroll.create_special_period")}
            open={isModalOpen}
            onOk={form.submit}
            onCancel={onCancel}
            style={{
                body: {
                    maxHeight: "65vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    scrollbarWidth: "none",
                }
            }}
            footer={null}
            closable={false}
            maskClosable={false}
        >

            <FormAntd
                colon={false}
                form={form}
                requiredMark={RequiredMark}
                onFinish={onCreateSpecial}
            >
                <Form.Item
                    shouldUpdate
                >
                    <Steps style={{ marginTop: 24 }} current={current} items={items} />

                    <div style={{ marginTop: 24 }}>{steps[current].content}</div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 36 }}>
                        {current === 1 && (
                            <span style={{ alignContent: "center" }}>{`${t("payroll_period.selected")} ${checkedList.length} ${t("payroll_period.items")}`}</span>
                        )}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flex: 1 }}>
                            {current < steps.length - 1 && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                    <Button
                                        key="cancelBtn"
                                        onClick={() => {
                                            form.resetFields();
                                            onCancel();
                                        }}
                                        type="default"
                                        style={{ height: "40px", borderRadius: "8px" }}
                                    >
                                        {t("payroll_period.label.cancel")}
                                    </Button>
                                    <Button type="primary" onClick={next} style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>{t("signup.nextBtn")}</Button>
                                </div>
                            )}
                            {current > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                    <Button onClick={prev}
                                        type="default"
                                        style={{ height: "40px", borderRadius: "8px" }}>
                                        {t("common.back")}
                                    </Button>
                                    <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>{t("payroll_period.submit_period")}</Button>
                                </div>
                            )}
                        </div>
                    </div>
                </Form.Item>
            </FormAntd>
        </Modal>
    )
}

export default CreateSpecialModal;